
// React Imports
import * as React from "react";
import {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from '@mui/x-data-grid';
import IconButton from "@mui/material/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import {
    Avatar,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    ListItemIcon,
    ListItemText,
    Menu,
    Stack,
    Tooltip
} from "@mui/material";

// App Imports
import {
    deleteProfile, profileSearch
} from "./ProfileClient";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {changeProfile} from "./profileSlice";
import {changeCrudSnackbar} from "../../CommonComponents/crudSnackbarSlice";
import ProfileDrawer from "./ProfileDrawer";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import {changeUploadFile} from "../../CommonComponents/UploadFile/uploadFileSlice";
import Button from "@mui/material/Button";
import UploadFileDrawer from "../../CommonComponents/UploadFile/UploadFileDrawer";
import SearchIcon from "@mui/icons-material/Search";
import ProfileSearch from "./ProfileSearch";
import AddFiltersExportToolbar from "../../CommonComponents/AddFiltersExportToolbar";
import {SubscriberGridColumns} from "../Subscriber/SubscriberGridColumns";
import {changeSubscriber} from "../Subscriber/subscriberSlice";
import {ProfileGridColumns} from "./ProfileGridColumns";
import {changeExternalData} from "../externalDataSlice";
import NoSearchCriteriaSnackbar from "../../CommonComponents/NoSearchCriteriaSnackbar";
import ProfileInfoDialogue from "./Info/ProfileInfoDialgue";

// main function
export default function ProfileGrid() {

    // ****************** BEGIN STATES ****************************

    const [profiles, setProfiles] = useState([]);
    const [deleteOpen, setDeleteOpen] = React.useState(false);
    const [gridVisible, setGridVisible] = React.useState(true);
    const [showControls, setShowControls] = useState(true);
    const [showSearch, setShowSearch] = useState(false);
    const hideActions = localStorage.getItem('hideActions') === "true";
    const [profileInfoOpen, setProfileInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const selectorProfileId = useSelector((state) => state.profileSlc.value.id);
    const selectorProfileMcode = useSelector((state) => state.profileSlc.value.mcode);
    const selectorProfileName = useSelector((state) => state.profileSlc.value.name);
    const selectorProfileDescription = useSelector((state) => state.profileSlc.value.description);
    const selectorProfileCategory = useSelector((state) => state.profileSlc.value.category);
    const selectorDrawerState = useSelector((state) => state.profileSlc.value.profileDrawerState);

    const selectorUploadFileDrawerState = useSelector((state) => state.uploadFileSlc.value.uploadFileDrawerState);

    const selectorId = useSelector((state) => state.profileSearchSlc.value.id);
    const selectorExternalId = useSelector((state) => state.profileSearchSlc.value.externalId);
    const selectorFirstName = useSelector((state) => state.profileSearchSlc.value.firstName);
    const selectorLastName = useSelector((state) => state.profileSearchSlc.value.lastName);
    const selectorSsn = useSelector((state) => state.profileSearchSlc.value.ssn);
    const selectorDateOfBirthFrom = useSelector((state) => state.profileSearchSlc.value.dateOfBirthFrom);
    const selectorDateOfBirthTo = useSelector((state) => state.profileSearchSlc.value.dateOfBirthTo);
    const selectorMinor = useSelector((state) => state.profileSearchSlc.value.minor);
    const selectorDateOfDeathFrom = useSelector((state) => state.profileSearchSlc.value.dateOfDeathFrom);
    const selectorDateOfDeathTo = useSelector((state) => state.profileSearchSlc.value.dateOfDeathTo);
    const selectorLivingOrDead = useSelector((state) => state.profileSearchSlc.value.livingOrDead);
    const selectorCompanyName = useSelector((state) => state.profileSearchSlc.value.companyName);
    const selectorFein = useSelector((state) => state.profileSearchSlc.value.fein);
    const selectorDateOfDissolutionFrom = useSelector((state) => state.profileSearchSlc.value.dateOfDissolutionFrom);
    const selectorDateOfDissolutionTo = useSelector((state) => state.profileSearchSlc.value.dateOfDissolutionTo);
    const selectorPaymentSystem = useSelector((state) => state.profileSearchSlc.value.paymentSystem);
    const selectorPayStatus = useSelector((state) => state.profileSearchSlc.value.payStatus);
    const selectorStatus = useSelector((state) => state.profileSearchSlc.value.status);
    const selectorParticipations = useSelector((state) => state.profileSearchSlc.value.participations);
    const selectorResiduals = useSelector((state) => state.profileSearchSlc.value.residuals);
    const selectorRoyalties = useSelector((state) => state.profileSearchSlc.value.royalties);

    const selectedId = useSelector((state) => state.profileSlc.value.id);

    const dispatchData = useDispatch();

    const selectorProfileGridRefresh = useSelector((state) => state.profileSlc.value.profileGridRefresh);

    // ********************** END STORE ********************************


    // ****************** BEGIN FETCH ****************************

    // const fetchProfiles = () =>{
    //     if(
    //         selectorId !== null ||
    //             selectorExternalId !== null ||
    //             selectorFirstName !== null ||
    //             selectorLastName !== null ||
    //             selectorSsn !== null ||
    //             selectorDateOfBirthFrom !== null ||
    //             selectorDateOfBirthTo !== null ||
    //             selectorMinor !== null ||
    //             selectorDateOfDeathFrom !== null ||
    //             selectorDateOfDeathTo !== null ||
    //             selectorLivingOrDead !== null ||
    //             selectorCompanyName !== null ||
    //             selectorFein !== null ||
    //             selectorDateOfDissolutionFrom !== null ||
    //             selectorDateOfDissolutionTo !== null ||
    //             selectorPaymentSystem !== null ||
    //             selectorPayStatus !== null ||
    //             selectorStatus !== null ||
    //         selectorParticipations !== null ||
    //         selectorResiduals !== null ||
    //         selectorRoyalties !== null
    //     )
    //     {
    //         {
    //             profileSearch(
    //                 selectorId,
    //                 selectorExternalId,
    //                 selectorFirstName,
    //                 selectorLastName,
    //                 selectorSsn,
    //                 selectorDateOfBirthFrom,
    //                 selectorDateOfBirthTo,
    //                 selectorMinor,
    //                 selectorDateOfDeathFrom,
    //                 selectorDateOfDeathTo,
    //                 selectorLivingOrDead,
    //                 selectorCompanyName,
    //                 selectorFein,
    //                 selectorDateOfDissolutionFrom,
    //                 selectorDateOfDissolutionTo,
    //                 selectorPaymentSystem,
    //                 selectorPayStatus,
    //                 selectorStatus,
    //                 selectorParticipations,
    //                 selectorResiduals,
    //                 selectorRoyalties
    //             )

    //                 .then(data => {
    //                         console.log(data);
    //                         setProfiles(data);
    //                     }
    //                 )
    //         }
    //     }
    //     else{console.log("search triggered, nothing to search.")}}

    const fetchProfiles = () => {

        const request = {

            id: selectorId,

            externalId: selectorExternalId,

            firstName: selectorFirstName,

            lastName: selectorLastName,

            ssn: selectorSsn,

            dateOfBirthFrom: selectorDateOfBirthFrom,
            dateOfBirthTo: selectorDateOfBirthTo,

            minor: selectorMinor,

            dateOfDeathFrom: selectorDateOfDeathFrom,
            dateOfDeathTo: selectorDateOfDeathTo,

            livingOrDead: selectorLivingOrDead,

            companyName: selectorCompanyName,

            fein: selectorFein,

            dateOfDissolutionFrom: selectorDateOfDissolutionFrom,
            dateOfDissolutionTo: selectorDateOfDissolutionTo,

            paymentSystem: selectorPaymentSystem,

            payStatus: selectorPayStatus,

            status: selectorStatus,

            participations: selectorParticipations,

            residuals: selectorResiduals,

            royalties: selectorRoyalties
        };

        console.log(
            JSON.stringify(request, null, 2)
        );

        const hasSearchCriteria = Object.values(request).some(
            value =>
                value !== null &&
                value !== undefined &&
                value !== ''
        );

        if (hasSearchCriteria) {

            dispatchData(changeExternalData({ submitting: true }));

            profileSearch(request)


                .then(data => {

                    console.log(data);

                    setProfiles(data);

                    if (!data || data.length === 0) {
                        console.log("no matching records found");
                        dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "info", snackbarMessage: "No matching records found" }));
                    }


                })

                .catch(err => {

                    console.error(err);

                })

                .finally(() => {

                    // setSubmitting(false);
                    dispatchData(changeExternalData({ submitting: false }));
                });


        } else {

            console.log(
                "search triggered, nothing to search."
            );
            dispatchData(changeExternalData({ snackbarOpen: true, snackbarSeverity: "warning", snackbarMessage: "No search criteria provided" }));
        }
    };

    // ****************** END FETCH ****************************

    const handleUploadFileDrawer = () => {
        console.log("upload file drawer state changed");
        dispatchData(changeUploadFile({uploadFileDrawerState: true,
            uploadFileDrawerMode: "Profile"}));
    };

    const renderProfiles = profiles => {
        if (profiles.length <= 0) {
            return "No Data";
        }}

    function handleControls(){
        setShowControls(!showControls)
    }
    //
    // useEffect(() => {
    //     fetchProfiles();
    //     dispatchData(changeProfile({profileGridRefresh: false}));
    // }, [useSelector((state) => state.profileSlc.value.profileGridRefresh)===true]);

    useEffect(() => {

        if (selectorProfileGridRefresh) {

            fetchProfiles();

            dispatchData(changeProfile({
                profileGridRefresh: false
            }));
        }

    }, [selectorProfileGridRefresh]);

    // ****************** BEGIN CRUD ***********************************

    const handleAdd = () => {
        dispatchData(changeProfile({id: null, externalId: null, firstName: null, lastName: null,
            ssn: null, dateOfBirth: null, dateOfDeath: null, companyName: null,
            fein: null,dateOfDissolution:null,streetAddress:null,city:null,
            stateProvince: null, postalCode: null, country: null, payStatus: null, status: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            profileDrawerState: true, profileDrawerMode: "Add"}));
    };


    const removeProfile = () => {
        deleteProfile(selectorProfileId).then(() => {
            setDeleteOpen(false);
            dispatchData(changeProfile({profileGridRefresh: true}));
            dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
        })
    }

    const handleDeleteOpen = () => {
        setDeleteOpen(true);
    };

    function DeleteConfirmationDialog() {


        const handleClickOpen = () => {
            setDeleteOpen(true);
        };

        const handleClose = () => {
            setDeleteOpen(false);
        };


        const handleDelete = () => {
            deleteProfile(selectedId).then(() => {
                setDeleteOpen(false);
                dispatchData(changeProfile({profileGridRefresh: true}));
                dispatchData(changeCrudSnackbar({crudOpen: true, crudSeverity: "success", crudMessage: "Record deleted"}));
            })
            console.log('Item deleted');
        };

        return (
            <Dialog
                open={deleteOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'transparent', // makes backdrop transparent
                        boxShadow: '0 0 10px 5px rgba(0, 0, 0, 0.5)' // custom shadow box effect
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title">{"Confirm Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this item? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleDelete} autoFocus color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
    const handleDeleteCancel = () => {
        setDeleteOpen(false);
    };
    function handleSearch(){
        setShowSearch(!showSearch)
    }


    const gridClear = () => {

        setProfiles([]);
    }



    // ****************** END CRUD ***********************************


    const handleClickedRow = (profiles) => {

        console.log('Profile data from clicked row');
        console.log(profiles);
        dispatchData(changeProfile({id: profiles.id, externalId: profiles.externalId,
            firstName: profiles.firstName, lastName: profiles.lastName,
            ssn: profiles.ssn, dateOfBirth: profiles.dateOfBirth, dateOfDeath: profiles.dateOfDeath,
            companyName: profiles.companyName,
            fein: profiles.fein,dateOfDissolution:profiles.dateOfDissolution,
            streetAddress:profiles.streetAddress,city:profiles.city,
            stateProvince: profiles.stateProvince, postalCode: profiles.postalCode,
            country: profiles.country, payStatus: profiles.payStatus, status: profiles.status,
            createdOn: profiles.createdOn,createdBy:profiles.createdBy,
            lastModifiedOn:profiles.lastModifiedOn,lastModifiedBy:profiles.lastModifiedBy}));
    };


    const handleProfileInfo = () => {
        setProfileInfoOpen(true);
    };

    const handleCloseProfileInfo = () => {
        setProfileInfoOpen(false);
    };



    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height:800 , width: '100%' }}>
            <Box sx={{height: 80, pt: 1, pl: 3}}>
                <Stack direction={"horizontal"}>
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Click for information."}>
                    <h3
                        style={{cursor:'pointer'}}   onClick={() => handleProfileInfo()}
                    >Profiles</h3>
                    </Tooltip>
                        <ProfileInfoDialogue
                            open={profileInfoOpen}
                            onClose={handleCloseProfileInfo}
                        />
                    {/*<SearchIcon*/}
                    {/*    sx={{pt: 2, ml: 2}}*/}
                    {/*    color={'primary'}*/}
                    {/*    onClick={handleSearch}*/}
                    {/*/>*/}
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconButton
                            color="primary"
                            size="large"               // large icon & hit area
                            onClick={handleSearch}
                            sx={{ ml: 2 }}             // any spacing you want
                        >
                            <SearchIcon fontSize="inherit" />
                        </IconButton>
                    </Box>
                    <Button sx={{pt: 1, ml: 3}}
                            onClick={handleUploadFileDrawer}
                    >Upload</Button>
                </Stack>
            </Box>
            {showSearch && <ProfileSearch
                gridClear = {gridClear}
            />}
            {selectorUploadFileDrawerState && <UploadFileDrawer/>}
            {selectorDrawerState && <ProfileDrawer
            />}
            {/*}*/}
            {gridVisible && <DataGrid
                experimentalFeatures={{ newEditingApi: true }}
                initialState={{
                }}
                aria-label={"Profiles"}
                rows={profiles}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={ProfileGridColumns({
                    profiles,
                    hideActions,
                    onEdit: () => dispatchData(changeProfile({ profileDrawerState: true, profileDrawerMode: "Edit" })),
                    onClone: () => dispatchData(changeProfile({ profileDrawerState: true, profileDrawerMode: "Clone" })),
                    onDelete: removeProfile
                })}
                onRowClick = {(profiles)=>handleClickedRow(profiles.row)}
                density={"compact"}
                pageSize={20}
                rowsPerPageOptions={[20]}
                rowKey={profile => profile.id}
                components={{
                    Toolbar: AddFiltersExportToolbar,
                    Footer: CustomFooter,
                }}
                componentsProps={{
                    toolbar: {
                        handleAdd: handleAdd
                    }
                }}
            />}
            <CrudSnackbar/>
            <NoSearchCriteriaSnackbar/>
        </div>

    );

    // ****************** END RETURN ****************************

}



